module.exports = __webpack_public_path__ + "svg/dice-white.svg?10b8073f5b350ed1b6350a0f472364bb";